export default __webpack_public_path__ + "6a18af671c6967b1d103a9b37ea42017.jpg";